<template>
  <div class="nnform-element-container">
    <div class="checkout-variant-list">

      <label class="checkout-variant" v-for="(item,index) in items">

        <input
            class="checkout-variant-input"
            type="radio"
            :name="name"
            :value="item.id"
            @input="handler"
        >

        <div class="checkout-variant-wrapper">
          <div class="checkout-variant-check"></div>
          <div class="checkout-variant-image-wrapper">
            <img class="checkout-variant-image" :src="item.icon">
          </div>
          <div class="checkout-variant-name">{{ item.name }}</div>
        </div>
      </label>
    </div>

    <div class="nnform-error" v-if="this.error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "CheckoutVariants",
  props: {
    modelValue: null,
    name: String,
    error: String,
    items: [],
  },
  methods: {
    handler(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$emit("unset");
      this.$emit('refresh');
    },
  },
}
</script>

<style scoped>

</style>